<template src="@/components/SearchBar.html"></template>
<style lang="scss" scoped src="@/components/SearchBar.scss"></style>

<script>
import {
    SfButton,
    SfIcon,
    SfLoader,
    SfSearchBar,
} from '@storefront-ui/vue';

import {clickOutside} from '@storefront-ui/vue/src/utilities/directives/click-outside/click-outside-directive.js';

import SearchAutocomplete from "@/components/SearchAutocomplete";
import OrkSvgIcon from "@/components/Ork/OrkSvgIcon"
import debounce from 'lodash/debounce';
import { icons } from '@/utils/icons'
import Api from "@/api/Api";

export default {
    name: 'SearchBar',
    components: {
        SfButton,
        SfIcon,
        SfLoader,
        SfSearchBar,
        SearchAutocomplete,
        OrkSvgIcon
    },
    directives: {clickOutside},
    props: {
        placeholderMessageKey: {
            type: String,
            default: "pages.search.placeholder"
        },
        enableAutocomplete: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchTerm: null,
            previousSearchTerm: null,
            autocompleteResults: [],
            loadingSearch: false,
            showAutocomplete: false,
            lastAutocompletePromise: null
        }
    },
    computed: {
        isSearchTermValid() { return this.searchTerm?.split(' ').filter(word => word && word.length >= 2).length > 0 },
        isOnSearchPage() { return this.$route.name === "Search"},
        storeSearchTerm() { return this.$store.getters.getSearchTerm }
    },
    watch: {
        storeSearchTerm: {
            handler: function (newValue) {
                this.searchTerm = newValue
            },
            immediate: true
        }
    },
    methods: {
        handleSearchAutoComplete: debounce(function(term) {
            if (!this.enableAutocomplete) return

            // Used to prevent duplicate autocomplete calls, cause sometimes the watcher gets called but without real change.
            // Without this, there's an annoying behaviour of the autocomplete dropdown that is displayed after we press enter to validate the search.
            // We can't rely on this.searchTerm for this detection as it is bound and already updated when we reach this watcher.
            
            if (this.previousSearchTerm === term) return;

            this.previousSearchTerm = this.searchTerm
            this.searchTerm = term
            this.autocompleteResults = []
            if (this.isSearchTermValid) {
                this.loadingSearch = true
                const promise = this.lastAutocompletePromise = Api.product.searchAutocomplete(term)
                .then((data) => {
                    if (promise === this.lastAutocompletePromise) {
                        this.showAutocomplete = true
                        this.autocompleteResults = data
                    }
                }).catch(() => {
                    this.$store.dispatch('sendNotification', {
                        type: 'danger',
                        message: this.$i18n.t('server error'),
                        icon: icons.error
                    });
                }).finally(() => {
                    this.loadingSearch = false
                })
            }
        }, 400),
        closeAutocomplete() {
            this.showAutocomplete = false;
        },
        clickOnSuggestion(item) {
            this.searchTerm = null
            this.previousSearchTerm = null
            this.showAutocomplete = false

            // prevent running autocomplete task to be achived
            this.lastAutocompletePromise = null

            this.$router.push('/produit/' + item.slug)
        },
        changeSearchTerm(term) {
            this.previousSearchTerm = this.searchTerm
            this.searchTerm = term
            this.showAutocomplete = false

            // prevent running autocomplete task to be achived
            this.lastAutocompletePromise = null

            if (this.isSearchTermValid) {
                Api.marketingEvent.search(this.searchTerm)
                if (this.isOnSearchPage) {
                    this.$router.replace({
                      query: {
                        ...this.$route.query,
                        searchTerm: this.searchTerm,
                        filters: null
                      }
                    })
                } else {
                    this.$router.push("/recherche?searchTerm=" + this.searchTerm)
                }
                this.autocompleteResults = []
            }
        },
    }
};
</script>